<template>
  <div class="card floating" id="create-unit">
    <button class="button button-close"
      @click="$store.commit('closeHovers')"
      :aria-label="$t('buttons.close')"
      :title="$t('buttons.close')">
      <x-icon size="1.5x" class="custom-class"></x-icon>
    </button>
    <h2>{{ $t('sharedDrive.createUnit') }}</h2>
    <div style="padding: 0 30px;">
      <input class="input input--block" v-focus type="text" v-model="name" :placeholder="$t('login.firstname')" autocomplete="off">
    </div>
    <div v-if="isReady" ref="list-users" class="input-users">
      <shared-user v-for="(user, index) in users" :key="user.handle" v-bind:contactsSelected="contactsSelected" v-bind:handle="user.handle" v-bind:name="user.name" v-bind:accesslevel="user.accesslevel"
      v-bind:index="index" @update-value="updateValue" @remove-user="removeUser" @select-contact="selectContact" @scroll-users="scrollUsers"></shared-user>
    </div>
    <button v-if="$route.hash === ''" id="addButton" @click="addUser()" :aria-label="$t('sharedDrive.addAnotherUser')" :title="$t('sharedDrive.addAnotherUser')" :disabled="isDisabled">
      <plus-circle-icon size="1.5x" class="custom-class"></plus-circle-icon>
      <span>{{ $t('sharedDrive.addAnotherUser') }}</span>
    </button>
    <div class="botones">
      <button id="cancelButton" @click="$store.commit('closeHovers')" :aria-label="$t('buttons.cancel')" :title="$t('buttons.cancel')">
        <span>{{ $t('buttons.cancel') }}</span>
      </button>
      <button id="openButton" @click="createUnit" :aria-label="$t('sharedDrive.createUnit')" :title="$t('sharedDrive.createUnit')" :disabled="name === ''">
        <span>{{ $t('sharedDrive.createUnit') }}</span>
      </button>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import { XIcon, PlusCircleIcon } from 'vue-feather-icons';
import SharedUser from '@/components/shared-drive/SharedUser.vue';

export default {
  name: 'create-unit',
  data: function () {
    return {
      name: '',
      users: [''],
      contacts: [],
      contactsSelected: [],
      isDisabled: true,
      isReady: false
    };
  }, 
  components: {
    XIcon,
    PlusCircleIcon,
    SharedUser
  },
  computed: {
  },
  async mounted () {
    window.addEventListener('keydown', this.keyEvent);

    if (this.$route.hash !== '') {
      let parentHandle = this.$route.hash.replace('#', '');
      let action = await ibb.getSharedDriveInfo(parentHandle);
      this.users = action.accountPermissions.filter(item => item.handle !== '').map(user => ({handle: user.handle, name: user.name, accesslevel: user.accesslevel}));
    }

    this.isReady = true;

    let action = await ibb.getRootNode(Module.NodeType.CONTACT_ROOT.value);
    if (action.error.type) {
      throw new Error('Error getting root node: ' +  action.error.type);
    }
    const {nodeList} = await ibb.getChildren(action.node.handle);
    let index = -1;
    for (let contact of nodeList) {
      if (contact.name === 'Contacto Externo') {
        index = nodeList.indexOf(contact);
      }
    }
    if (index > -1) {
      nodeList.splice(index, 1);
    }
    this.contacts = nodeList;
  },
  beforeDestroy () {
    window.removeEventListener('keydown', this.keyEvent);
  },
  methods: {
    ...mapMutations(['closeHovers']),
    keyEvent (event) {
      // Enter
      if (event.keyCode === 13) {
        if (this.name !== '') {
          this.createUnit();
        }
      }
    },
    async createUnit() {
      let action;
      if (this.$route.hash === '') {
        action = await ibb.createSharedDrive(this.name);
      } else {
        let parentHandle = this.$route.hash.replace('#', '');
        action = await ibb.createVirtuallyNestedSharedDrive(parentHandle, this.name);
      }
      if (action.error.type) {
        throw new Error('Error creatting shared drive: ' +  action.error.type);
      }
      let flagError = false;
      let handle = action.node.handle;
      if (this.users.length > 0) {
        for (let user of this.users) {
          if (user !== '' && user.name !== undefined) {
            if (user.name.includes('https://iberbox.com')) {
              action = await ibb.shareDriveWithAccountByLinkWithAccessLevel(handle, user.name, user.accesslevel);
              if (action.error.type) {
                flagError = true;
              } 
              //Se añade el contacto
              action = await ibb.getPublicAccountInfoByLink(user.name) ;
              let accountHandle = action.accountHandle;
              let name = action.name;
              action = await ibb.addContact(accountHandle, name);
            } else {
              for (let contact of this.contacts) {
                if (contact.name === user.name) {
                  action = await ibb.shareDriveWithAccountAndAccessLevel(handle, contact.accountHandle, user.accesslevel);
                  if (action.error.type) {
                    flagError = true;
                  } 
                }
              }
            }
          }
        }
      }
      if (flagError) {
        this.$showError(this.$t('sharedDrive.notShared'));
      }

      this.$store.commit('closeHovers');
    },
    async addUser() {
      this.users = [...this.users, ''];
      await this.$nextTick();
      this.$refs['list-users'].scroll({
        top: this.$refs['list-users'].scrollHeight,
        behavior: 'smooth'
      });
      this.isDisabled = true;
    },
    removeUser(index) {
      let i = this.contactsSelected.indexOf(this.users[index]);
      this.contactsSelected.splice(i, 1);
      if (index !== 0) {
        this.users.splice(index, 1);
      }
    },
    selectContact(contact) {
      this.contactsSelected.push(contact);
    },
    updateValue (val, index, accesslevel, handle) {
      const usuario = {
        handle: handle,
        name: val,
        accesslevel: accesslevel,
      };
      this.users[index] = usuario;
      if (val !== '' && val !== undefined) {
        this.isDisabled = false;
      } 
    },
    async scrollUsers() {
      await this.$nextTick();
      this.$refs['list-users'].scroll({
        top: this.$refs['list-users'].scrollHeight,
        behavior: 'smooth'
      });
    }
  }
};
</script>